/**
 * Reducer pro nekonečný scroll - klientský.
 */
import {CHECKING_MY_IDS_REQUEST, CHECKING_MY_IDS_RESPONSE, RELOAD, UPDATED_REQUEST, UPDATED_META_REQUEST, UPDATED_RESPONSE, UPDATED_META_RESPONSE, CHANGES, LOAD_MORE_RESPONSE, LOAD_MORE_REQUEST, INVALIDATE, REQUEST, RESPONSE, FILTER, SELECT_PARENT, REMOVE} from './InfiniteListActions'
import getMapFromList from "./../../utils/getMapFromList";
import getSetFromIdsList from "./../../utils/getSetFromIdsList";

function getDataKey() {
    let dataKey = "";

    dataKey += JSON.stringify(this.filter);

    dataKey += "_" + this.parent;

    return dataKey;
}

/**
 * Stav pro reset načteých dat - mimo filtr.
 */
const resetState = {
    fetched: false,
    isFetching: false,
    loadingMore: false,
    dirty: true,
    allIds: [],
    rows: [],
    deletedIds: {},
    needUpdateIds: {},
    needUpdateMetaIds: {},
    addedIds: {},
    checkingMyIds: false,
    hasNewIds: false
};

const initialState = {
    loadingMore: false, // zde se ukládá, zda již načítá další data pro load more
    checkingMyIds: false,   // zda probíhá akce zjišťování svých id
    hasNewIds: false,   // true, pokud kontrola checkingMyIds nalezna reálné id pro nás
    hasMore: false,           // boolean, který má informaci o tom, zda existují další záznamy na donačtení
    dirty: false,   // pokud je true, neodpovídají data filtru, i když jsou načtená, při filtrování neodebráme data
    allIds: [],   // řádky, které odpovídají filtru, jen seznam id
    rows: [],   // řádky, které odpovídají aktuálnímu zobrazení, seznam načtených dat - objektů
    isFetching: false,
    fetched: false,
    filter: {},
    currentDataKey: "",
    allMetaMap: null,
    getDataKey: getDataKey,
    loadMoreCount: 150,  // počet záznamů, které se mají donačíst při dalším načítání seznamu dat - počet donačtených řádků
    reducer: list,
    parent: null,

    addedIds: [],   // pole seznamu id, které byly přidány
    deletedIds: {}, // mapa id->true, že je smazané, týká se pouze id, pro které máme již donačtené objety
    needUpdateIds: {},   // mapa id->true, že se má daný objekt při příštím zobrazení aktualizovat ze serveru
    needUpdateMetaIds: {},   // mapa id->true, že se má daný objekt při příštím zobrazení aktualizovat ze serveru - pouze meta
};

function loadMoreResponse(state, action) {
    // Pokud jsou nějaká id smazána, nemusejí se pro ně vrátit objekt, stejně tak result nemusí pořadím odpovídat pořadí předaných id
    const rowsMap = getMapFromList(action.rows);

    let loadedIds = [];    // upravený seznam id omezený o ty id, které již server nevrátil
    let loadedRows = [];
    action.requiredIds.forEach(id => {
        if (rowsMap[id]) {  // objekt byl na serveru načten a existuje (nebo je na něj oprávnění pro zobrazení)
            loadedIds.push(id);
            loadedRows.push(rowsMap[id]);
        } else {    // objekt nemá být uživateli z nějakého důvodu viditelný (např. byl smazán)
            // nebyly načteny, budou odebrány ze seznamu ve state, tedy ze state.allIds
        }
    });

    const newRows =[
        ...state.rows,
        ...loadedRows
    ];
    const newAllIds = [
        ...state.allIds.slice(0, state.rows.length),
        ...loadedIds,
        ...state.allIds.slice(state.rows.length + action.requiredIds.length),
    ];

    return {
        ...state,
        rows: newRows,
        allIds: newAllIds,
        hasMore: newRows.length < newAllIds.length,
        loadingMore: false
    }
}

function response(state, action) {
    return {
        ...state,
        isFetching: false,
        fetched: true,
        dirty: false,
        loadingMore: false,
        allIds: action.rows,
        rows: [],
        hasMore: action.rows.length > 0,
        count: action.count,
        deletedIds: {},
        needUpdateIds: {},
        needUpdateMetaIds: {},
        addedIds: {},
        checkingMyIds: false,
        hasNewIds: false,
        allMetaMap: action.allMetaMap
    }
}

export default function list(state = initialState, action = {}, config = null) {
    // Konfigurace
    if (config) {
        state = {...state};

        // Inicializace na základě konfigu
        if (config.loadMoreCount != null) {
            state.loadMoreCount = config.loadMoreCount;
        }
        if (config.filter) {    // inicializační filtr
            state.filter = config.filter
        }
    }

    // Vlastní akce
    switch (action.type) {
        case UPDATED_REQUEST: {
            return {
                ...state,
                needUpdateIds: {}
            };
        }
        case UPDATED_META_REQUEST: {
            return {
                ...state,
                needUpdateMetaIds: {}
            };
        }
        case UPDATED_RESPONSE: {
            const updatedObjectsMap = getMapFromList(action.rows);
            const updatedRows = state.rows.map(row => {
                // Pokud je objekt v seznamu aktualizovaných, použijeme ten, jinak použijeme ten, co máme ve store
                return updatedObjectsMap[row.id] ? updatedObjectsMap[row.id] : row;
            });
            return {
                ...state,
                rows: updatedRows,
            };
        }
        case UPDATED_META_RESPONSE: {
            const newAllMetaMap = {...state.allMetaMap};
            state.rows.forEach(row => {
                newAllMetaMap[row.id] = row;
            });
            return {
                ...state,
                allMetaMap: newAllMetaMap
            };
        }
        case CHECKING_MY_IDS_REQUEST:
            return {
                ...state,
                checkingMyIds: true,
            };
        case CHECKING_MY_IDS_RESPONSE:
            return {
                ...state,
                checkingMyIds: false,
                hasNewIds: action.hasNewIds,
                addedIds: action.hasNewIds ? [] : state.addedIds
            };
        case CHANGES: {
            // DELETED
            let newDeletedIds;
            let newAllIds;
            let newRows = state.rows;
            let newAllMetaMap = state.allMetaMap ? {...state.allMetaMap} : null;
            if (action.deletedIds.length > 0) {
                if (action.removeDeleted) {
                    // Kompletně odebereme deleted id a objekty
                    const deletedIdsMap = getSetFromIdsList(action.deletedIds);
                    newDeletedIds = state.deletedIds;
                    newRows = [];
                    state.rows.forEach(x => {
                        if (!deletedIdsMap[x.id]) {  // nebyl smazán, necháme
                            newRows.push(x);
                        }
                    });
                    newAllIds = [];
                    state.allIds.forEach(id => {
                        if (!deletedIdsMap[id]) {  // nebyl smazán, necháme
                            newAllIds.push(id);
                        } else {    // byl smazán, odebereme meta, pokud máme
                            if (newAllMetaMap) {
                                delete newAllMetaMap[id];
                            }
                        }
                    });
                } else {
                    // U objektů, které máme již načtené si můžeme uchovat příznak, že jsou smazány
                    // Smazaná id odebereme ze seznamu id, pro které ještě nemáme načtené objekty
                    const deletedIdsMap = getSetFromIdsList(action.deletedIds);
                    newDeletedIds = { ...state.deletedIds };
                    newAllIds = [];
                    state.allIds.forEach((id, index) => {
                        if (index < state.rows.length) {    // id, pro které máme načtený objekt
                            newAllIds.push(id); // id v seznamu musíme zachovat, protože si necháváme i objekt, jen si u něj pamatujeme, že je smazaný
                            if (deletedIdsMap[id]) {   // máme objekt, ale byl smazaný
                                newDeletedIds[id] = true;
                            }
                        } else {    // id, pro které ještě načtený objekt nemáme
                            if (!deletedIdsMap[id]) {   // pokud není smazané, zachováme ho v seznamu id
                                newAllIds.push(id);
                            }
                        }
                    });
                }
            } else {
                newDeletedIds = state.deletedIds;
                newAllIds = state.allIds;
            }

            // CREATED
            // U objektů které přibily nic neděláme - zatím, v budoucnu můžeme např. uživateli zobrazit info, že jsou nové - ale musíme si být jisti, že dané id jsou opravdu pro něho např. s respektováním aktuálního filtru
            // Jen si uložíme příznak, že si myslíme, že máme nové id - můžeme využít např. v případě did mount na reload
            let newAddedIds = [
                ...state.addedIds,
                ...action.createdIds
            ];

            // UPDATED
            // Pokud mám pro nějaké předané id načtený objekt, měl by se (pokud se list zobrazuje uživateli) načíst znovu ze serveru
            let newNeedUpdateIds;
            let newNeedUpdateMetaIds;
            if (action.updatedIds.length > 0) {
                const updatedIdsMap = getSetFromIdsList(action.updatedIds);

                // Aktualizace seznamu id objektů, které se změnily a máme pro ně načtené objekty ze serveru
                newNeedUpdateIds = { ...state.needUpdateIds };
                for (let a=0; a<state.rows.length; a++) {
                    let id = state.allIds[a];
                    if (updatedIdsMap[id]) {
                        newNeedUpdateIds[id] = true; // máme ho jako objekt a chceme ho aktualizovat při příštím zobrazení
                    }
                }

                // Aktualizace seznamu id pro meta - změnily se objekty, pro které máme načtené meta informace
                if (state.allMetaMap) {
                    newNeedUpdateMetaIds = {...state.needUpdateMetaIds};
                    for (let a=0; a<action.updatedIds.length; a++) {
                        let id = action.updatedIds[a];
                        if (state.allMetaMap[id]) { // evidujeme pro něj meta, budeme ho chtít aktualizovat
                            newNeedUpdateMetaIds[id] = true;
                        }
                    }
                } else {
                    newNeedUpdateMetaIds = {};
                }
            } else {
                newNeedUpdateIds = state.needUpdateIds;
                newNeedUpdateMetaIds = state.needUpdateMetaIds;
            }

            return {
                ...state,
                rows: newRows,
                allIds: newAllIds,
                addedIds: newAddedIds,
                deletedIds: newDeletedIds,
                needUpdateIds: newNeedUpdateIds,
                needUpdateMetaIds: newNeedUpdateMetaIds,
                allMetaMap: newAllMetaMap
            };
        }
        case LOAD_MORE_REQUEST: {
            return {
                ...state,
                loadingMore: true
            }
        }
        case LOAD_MORE_RESPONSE: {
            return loadMoreResponse(state, action);
        }
        case RELOAD:
            const responseAction = {
                rows: action.ids,
                count: 0,
                allMetaMap: action.allMetaMap,
                needUpdateMetaIds: {}
            };
            const loadMoreAction = {
                rows: action.rows,
                requiredIds: action.requiredIds
            };
            return loadMoreResponse(response(state, responseAction), loadMoreAction);
        case INVALIDATE:
            return {
                ...state,
                dirty: true,
                currentDataKey: "",
                loadingMore: false,
            };
        case REQUEST:
            return {
                ...state,
                isFetching: true,
                currentDataKey: action.dataKey,
                loadingMore: false
            };
        case SELECT_PARENT:
            // Při změně parenta invaildujeme všechna data
            return {
                ...state,
                parent: action.parent,
                ...resetState
            };
        case RESPONSE: {
            return response(state, action);
        }
        case FILTER: {
            return {
                ...state,
                filter: action.filter,
                dirty: true,
                ...(action.resetData ? resetState : {})
            };
        }
        case REMOVE: {
            const idsSet = getSetFromIdsList(action.ids);
            return {
                ...state,
                allIds: state.allIds.filter(id => !idsSet[id]),
                rows: state.rows.filter(row => !idsSet[row.id]),
            };
        }
        default:
            return state
    }
}

// let store = list();
//
// console.log("INIT", store);
//
// store = list(store, {
//     type: REQUEST,
//     dataKey: "X"
// });
// console.log("after REQUEST", store);
//
// store = list(store, {
//     type: RESPONSE,
//     rows: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
//     count: 10,
// });
// console.log("after RESPONSE", store);
//
// store = list(store, {
//         type: LOAD_MORE_RESPONSE,
//         rows: [{id: 1}, {id: 4}, {id: 5}],
//         requiredIds: [1, 2, 3, 4, 5]
//     }
// );
// console.log("after LOAD_MORE_RESPONSE", store);
//
// store = list(store, {
//         type: LOAD_MORE_RESPONSE,
//         rows: [{id: 8}, {id: 9}, {id: 10}],
//         requiredIds: [6, 7, 8, 9, 10]
//     }
// );
// console.log("after LOAD_MORE_RESPONSE", store);

